import { StrictLocalizeFunction } from "@faire/web--source/common/localization";

export const INBOUND_BRAND_CATEGORY_OPTIONS = (
  strictLocalize: StrictLocalizeFunction
) => [
  {
    label: strictLocalize({
      defaultMessage: "Home Decor",
      description: { text: "Category of products that a brand sells" },
    }),
    value: "Home Decor",
    popularity: 0,
    subCategories: [
      {
        label: strictLocalize({
          defaultMessage: "Bath",
          description: { text: "Category of products that a brand sells" },
        }),
        value: "Bath",
      },
      {
        label: strictLocalize({
          defaultMessage: "Bedding",
          description: { text: "Category of products that a brand sells" },
        }),
        value: "Bedding",
      },
      {
        label: strictLocalize({
          defaultMessage: "Candles & Holders",
          description: { text: "Category of products that a brand sells" },
        }),
        value: "Candles & Holders",
      },
      {
        label: strictLocalize({
          defaultMessage: "Garden & Outdoor",
          description: { text: "Category of products that a brand sells" },
        }),
        value: "Garden & Outdoor",
      },
      {
        label: strictLocalize({
          defaultMessage: "Home Accents & Fragrances",
          description: { text: "Category of products that a brand sells" },
        }),
        value: "Home Accents & Fragrances",
      },
      {
        label: strictLocalize({
          defaultMessage: "Household Supplies & DIY",
          description: { text: "Category of products that a brand sells" },
        }),
        value: "Household Supplies & DIY",
      },
      {
        label: strictLocalize({
          defaultMessage: "Kitchen & Tabletop",
          description: { text: "Category of products that a brand sells" },
        }),
        value: "Kitchen & Tabletop",
      },
      {
        label: strictLocalize({
          defaultMessage: "Storage & Organization",
          description: { text: "Category of products that a brand sells" },
        }),
        value: "Storage & Organization",
      },
      {
        label: strictLocalize({
          defaultMessage: "Throw Pillows & Blankets",
          description: { text: "Category of products that a brand sells" },
        }),
        value: "Throw Pillows & Blankets",
      },
      {
        label: strictLocalize({
          defaultMessage: "Wall Decor",
          description: { text: "Category of products that a brand sells" },
        }),
        value: "Wall Decor",
      },
    ],
  },
  {
    label: strictLocalize({ defaultMessage: "Beauty & Wellness" }),
    value: "Beauty & Wellness",
    popularity: 2,
    subCategories: [
      {
        label: strictLocalize({
          defaultMessage: "Bath & Body",
          description: { text: "Category of products that a brand sells" },
        }),
        value: "Bath & Body",
      },
      {
        label: strictLocalize({
          defaultMessage: "Fitness & Yoga",
          description: { text: "Category of products that a brand sells" },
        }),
        value: "Fitness & Yoga",
      },
      {
        label: strictLocalize({
          defaultMessage: "Fragrance",
          description: { text: "Category of products that a brand sells" },
        }),
        value: "Fragrance",
      },
      {
        label: strictLocalize({
          defaultMessage: "Haircare",
          description: { text: "Category of products that a brand sells" },
        }),
        value: "Haircare",
      },
      {
        label: strictLocalize({
          defaultMessage: "Health & Wellness",
          description: { text: "Category of products that a brand sells" },
        }),
        value: "Health & Wellness",
      },
      {
        label: strictLocalize({
          defaultMessage: "Makeup",
          description: { text: "Category of products that a brand sells" },
        }),
        value: "Makeup",
      },
      {
        label: strictLocalize({
          defaultMessage: "Men’s grooming",
          description: { text: "Category of products that a brand sells" },
        }),
        value: "Men’s grooming",
      },
      {
        label: strictLocalize({
          defaultMessage: "Personal care",
          description: { text: "Category of products that a brand sells" },
        }),
        value: "Personal care",
      },
      {
        label: strictLocalize({
          defaultMessage: "Skincare",
          description: { text: "Category of products that a brand sells" },
        }),
        value: "Skincare",
      },
      {
        label: strictLocalize({
          defaultMessage: "Spa & Spiritual",
          description: { text: "Category of products that a brand sells" },
        }),
        value: "Spa & Spiritual",
      },
    ],
  },
  {
    label: strictLocalize({
      defaultMessage: "CBD/THC",
      description: { text: "Category of products that a brand sells" },
    }),
    value: "CBD/THC",
    subCategories: [],
    popularity: 17,
  },
  {
    label: strictLocalize({ defaultMessage: "Food & Drink" }),
    value: "Food & Drink",
    popularity: 4,
    subCategories: [
      {
        label: strictLocalize({
          defaultMessage: "Baking and Confections",
          description: { text: "Category of products that a brand sells" },
        }),
        value: "Baking",
      },
      {
        label: strictLocalize({
          defaultMessage: "Beverages",
          description: { text: "Category of products that a brand sells" },
        }),
        value: "Beverages",
      },
      {
        label: strictLocalize({
          defaultMessage: "Cereal, Grains, & Pastas",
          description: { text: "Category of products that a brand sells" },
        }),
        value: "Cereal, Grains, & Pastas",
      },
      {
        label: strictLocalize({
          defaultMessage: "Coffee & Tea",
          description: { text: "Category of products that a brand sells" },
        }),
        value: "Coffee & Tea",
      },
      {
        label: strictLocalize({
          defaultMessage: "Condiments & Sauces",
          description: { text: "Category of products that a brand sells" },
        }),
        value: "Condiments & Sauces",
      },
      {
        label: strictLocalize({
          defaultMessage: "Dairy & Meats",
          description: { text: "Category of products that a brand sells" },
        }),
        value: "Dairy & Meats",
      },
      {
        label: strictLocalize({
          defaultMessage: "Food Baskets & Kits",
          description: { text: "Category of products that a brand sells" },
        }),
        value: "Food Baskets & Kits",
      },
      {
        label: strictLocalize({
          defaultMessage: "Jams & Spreads",
          description: { text: "Category of products that a brand sells" },
        }),
        value: "Jams & Spreads",
      },
      {
        label: strictLocalize({
          defaultMessage: "Snacks",
          description: { text: "Category of products that a brand sells" },
        }),
        value: "Snacks",
      },
      {
        label: strictLocalize({
          defaultMessage: "Wine, Beer & Spirits",
          description: { text: "Category of products that a brand sells" },
        }),
        value: "Wine, Beer & Spirits",
      },
    ],
  },
  {
    label: strictLocalize({ defaultMessage: "Jewelry" }),
    value: "Jewelry",
    popularity: 11,
    subCategories: [
      {
        label: strictLocalize({
          defaultMessage: "Body & Jewelry",
          description: { text: "Category of products that a brand sells" },
        }),
        value: "Body & Jewelry",
      },
      {
        label: strictLocalize({
          defaultMessage: "Bracelets",
          description: { text: "Category of products that a brand sells" },
        }),
        value: "Bracelets",
      },
      {
        label: strictLocalize({
          defaultMessage: "Brooches",
          description: { text: "Category of products that a brand sells" },
        }),
        value: "Brooches",
      },
      {
        label: strictLocalize({
          defaultMessage: "Cufflinks & Tie Clips",
          description: { text: "Category of products that a brand sells" },
        }),
        value: "Cufflinks & Tie Clips",
      },
      {
        label: strictLocalize({
          defaultMessage: "Earrings",
          description: { text: "Category of products that a brand sells" },
        }),
        value: "Earrings",
      },
      {
        label: strictLocalize({
          defaultMessage: "Jewelry Sets",
          description: { text: "Category of products that a brand sells" },
        }),
        value: "Jewelry Sets",
      },
      {
        label: strictLocalize({
          defaultMessage: "Jewelry Storage & Care",
          description: { text: "Category of products that a brand sells" },
        }),
        value: "Jewelry Storage & Care",
      },
      {
        label: strictLocalize({
          defaultMessage: "Necklaces",
          description: { text: "Category of products that a brand sells" },
        }),
        value: "Necklaces",
      },
      {
        label: strictLocalize({
          defaultMessage: "Rings",
          description: { text: "Category of products that a brand sells" },
        }),
        value: "Rings",
      },
      {
        label: strictLocalize({
          defaultMessage: "Watches",
          description: { text: "Category of products that a brand sells" },
        }),
        value: "Watches",
      },
    ],
  },
  {
    label: strictLocalize({
      defaultMessage: "Kids & Baby - Apparel",
      description: { text: "Category of products that a brand sells" },
    }),
    value: "Kids & Baby - Apparel",
    popularity: 9,
    subCategories: [],
  },
  {
    label: strictLocalize({
      defaultMessage: "Kids & Baby - Non-Apparel",
      description: { text: "Category of products that a brand sells" },
    }),
    value: "Kids & Baby - Non-Apparel",
    popularity: 10,
    subCategories: [
      {
        label: strictLocalize({
          defaultMessage: "Bath & Safety",
          description: { text: "Category of products that a brand sells" },
        }),
        value: "Bath & Safety",
      },
      {
        label: strictLocalize({
          defaultMessage: "Gear & Essentials",
          description: { text: "Category of products that a brand sells" },
        }),
        value: "Gear & Essentials",
      },
      {
        label: strictLocalize({
          defaultMessage: "Maternity",
          description: { text: "Category of products that a brand sells" },
        }),
        value: "Maternity",
      },
      {
        label: strictLocalize({
          defaultMessage: "Nursery & Decor",
          description: { text: "Category of products that a brand sells" },
        }),
        value: "Nursery & Decor",
      },
      {
        label: strictLocalize({
          defaultMessage: "Paper & Novelty",
          description: { text: "Category of products that a brand sells" },
        }),
        value: "Paper & Novelty",
      },
      {
        label: strictLocalize({
          defaultMessage: "Toys & Learning",
          description: { text: "Category of products that a brand sells" },
        }),
        value: "Toys & Learning",
      },
    ],
  },
  {
    label: strictLocalize({ defaultMessage: "Men's Accessories" }),
    value: "Men's Accessories",
    popularity: 8,
    subCategories: [],
  },
  {
    label: strictLocalize({ defaultMessage: "Men's Apparel" }),
    value: "Men's Apparel",
    popularity: 7,
    subCategories: [],
  },
  {
    label: strictLocalize({
      defaultMessage: "Raw Materials",
      description: { text: "Category of products that a brand sells" },
    }),
    value: "Raw Materials",
    popularity: 18,
    subCategories: [],
  },

  {
    label: strictLocalize({ defaultMessage: "Paper & Novelty" }),
    value: "Paper & Novelty",
    popularity: 13,
    subCategories: [
      {
        label: strictLocalize({
          defaultMessage: "Books",
          description: { text: "Category of products that a brand sells" },
        }),
        value: "Books",
      },
      {
        label: strictLocalize({
          defaultMessage: "Crafts & Hobbies",
          description: { text: "Category of products that a brand sells" },
        }),
        value: "Crafts & Hobbies",
      },
      {
        label: strictLocalize({
          defaultMessage: "Games & Puzzles",
          description: { text: "Category of products that a brand sells" },
        }),
        value: "Games & Puzzles",
      },
      {
        label: strictLocalize({
          defaultMessage: "Gift wrapping",
          description: { text: "Category of products that a brand sells" },
        }),
        value: "Gift wrapping",
      },
      {
        label: strictLocalize({
          defaultMessage: "Greeting cards",
          description: { text: "Category of products that a brand sells" },
        }),
        value: "Greeting cards",
      },
      {
        label: strictLocalize({
          defaultMessage: "Party Supplies",
          description: { text: "Category of products that a brand sells" },
        }),
        value: "Party Supplies",
      },
      {
        label: strictLocalize({
          defaultMessage: "Stationary & writing",
          description: { text: "Category of products that a brand sells" },
        }),
        value: "Stationary & writing",
      },
      {
        label: strictLocalize({
          defaultMessage: "Stickers, Pins, Magnets",
          description: { text: "Category of products that a brand sells" },
        }),
        value: "Stickers, Pins, Magnets",
      },
    ],
  },
  {
    label: strictLocalize({ defaultMessage: "Pets" }),
    value: "Pets",
    popularity: 14,
    subCategories: [
      {
        label: strictLocalize({
          defaultMessage: "Cats",
          description: { text: "Category of products that a brand sells" },
        }),
        value: "Cats",
      },
      {
        label: strictLocalize({
          defaultMessage: "Dogs",
          description: { text: "Category of products that a brand sells" },
        }),
        value: "Dogs",
      },
      {
        label: strictLocalize({
          defaultMessage: "Other pets",
          description: { text: "Category of products that a brand sells" },
        }),
        value: "Other pets",
      },
    ],
  },
  {
    label: strictLocalize({ defaultMessage: "Women's Accessories" }),
    value: "Women's Accessories",
    popularity: 6,
    subCategories: [],
  },
  {
    label: strictLocalize({ defaultMessage: "Women's Apparel" }),
    value: "Women's Apparel",
    popularity: 5,
    subCategories: [],
  },
  {
    label: strictLocalize({ defaultMessage: "Other" }),
    value: "Other",
    popularity: 19,
    subCategories: [],
  },
];
